export default class A11yButton {
  constructor(element) {
    this.element = element
    this.element.addEventListener('keydown', this.handleKeydown.bind(this))
  }

  handleKeydown(event) {
    if (event.keyCode === 13) {
      event.currentTarget.dispatchEvent(new MouseEvent('click'))
    }
  }
}
